// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { RevenueCommissionValueItem } from './RevenueCommissionValueItem';
export class RevenueCommissionValueItemForPerFill extends RevenueCommissionValueItem {
    constructor() {
        super(...arguments);
        this.minTradedValue = 0.0;
    }
    get MinTradedValue() {
        return this.minTradedValue;
    }
    set MinTradedValue(value) {
        this.minTradedValue = value;
    }
    GetFixedCommissionValue(commission, ignoreMinMaxCorrection = false, markup = 1.0) {
        // For symbol info panel return value
        if (commission === 0) {
            return this.Value;
        }
        return commission < this.minTradedValue * markup ? 0 : this.Value * markup;
    }
}
